<template>
    <b-tab title="Roles">
        <div class="d-flex mb-3 w-auto">
            <div class="h4 mr-3">
                Roles
            </div>
            <div class="ml-auto mr-2">
                <b-button variant="success" @click.prevent="show_role_modal = true" :disabled="!can_create_roles">
                    <font-awesome-icon :icon="['fad', 'plus-square']" /> Add Role
                </b-button>
            </div>
        </div>
        <div>
            <b-spinner v-if="loading" label="Loading..."></b-spinner>
            <b-table
                v-else
                striped
                responsive
                sticky-header
                outlined
                no-border-collapse
                head-variant="light"
                :items="roles"
                :fields="fields"
            >
                <template #cell(permissions)="data">
                    <b-badge
                        variant="secondary"
                        v-for="item in data.value"
                        class="m-1"
                        :key="item.id"
                    >
                        {{ item.name }}
                    </b-badge>
                </template>

                <template #cell(actions)="data">
                    <div class="p-1">
                        <b-btn
                            class="m-1"
                            size="sm"
                            variant="outline-primary"
                            @click="editRole(data.item)"
                            :disabled="!can_edit_roles"
                        >
                            <font-awesome-icon :icon="['fad', 'edit']" fixed-width /> Edit
                        </b-btn>
                        <b-btn
                            class="m-1"
                            size="sm"
                            variant="outline-danger"
                            @click="deleteRole(data.item)"
                            :disabled="!can_delete_roles"
                        >
                            <font-awesome-icon :icon="['fad', 'trash']" fixed-width /> Delete
                        </b-btn>
                    </div>
                </template>
            </b-table>
        </div>

        <role-modal
            :visible="show_role_modal"
            :role="editable_role"
            @hide="clearRole"
        />
    </b-tab>
</template>

<style></style>

<script>
import {mapState} from 'vuex'
import RoleModal from '@/components/modals/admin/RoleModal.vue'
import moment from 'moment'

export default {
    name: 'RolesTab',
    components: {RoleModal},
    data: () => ({
        loading: false,
        fields: [
            {
                key: 'id',
                sortable: true,
                order_number: 1,
                thStyle: {
                    'width': '5%'
                },
            },
            {
                key: 'name',
                sortable: true,
                order_number: 2,
                thStyle: {
                    'width': '15%'
                },
            },
            {
                key: 'permissions',
                sortable: false,
                order_number: 3,
                thStyle: {
                    'width': '70%'
                },
            },
            {
                key: 'actions',
                sortable: false,
                order_number: 4,
                thStyle: {
                    'width': '10%'
                },
            },
        ],
        show_role_modal: false,
        editable_role: null,
    }),
    computed: {
        ...mapState({
            errors: state => state.errors.errors,
            roles: state => state.admin.roles,
            user: state => state.user.user,
        }),
        can_create_roles() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'create_role')
        },
        can_edit_roles() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'update_role')
        },
        can_delete_roles() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'delete_role')
        },
    },
    methods: {
        editRole(role) {
            this.editable_role = role
            this.show_role_modal = true
        },
        clearRole() {
            this.editable_role = null
            this.show_role_modal = false
        },
        async deleteRole(role) {
            const result = await this.$swal({
                html: `Delete role "${role.name}" ?`,
                showCancelButton: true,
                confirmButtonText: `Delete ${role.name}`,
                confirmButtonColor: '#E74C3C',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            })

            if (result.isConfirmed) {
                try {
                    await this.$store.dispatch('deleteAdminRole', role.id)
                    // reload the stores that would be updated
                    await this.$store.dispatch('getAdminUsers')
                    await this.$store.dispatch('getAdminPermissions')
                    await this.$store.dispatch('getAdminRoles')
                } catch (e) {
                    await this.$store.dispatch('pushError', {
                        data: {
                            message: `Failed to delete role: ${e.message}`,
                        },
                        time: moment().toISOString(),
                    })
                }
            }
        },
        async getRoles() {
            try {
                this.loading = true
                await this.$store.dispatch('getAdminRoles')
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to read roles: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            }

            this.loading = false
        }
    },
    mounted() {
        this.getRoles()
    }
}
</script>
